module.exports = __webpack_public_path__ + "static/jungle-8cf88f591ada89531fb9fe89e5c67922.png";